import React, { useEffect, useState } from "react";

import {
    createAdmin,
    deleteAdmin,
    getAdmins
} from "../../services/firebase/firestore";


const AdminAdministradores = ({ currentUserEmail }) => {

    const [admins, setAdmins] = useState([]);
    const [email, setEmail] = useState("");

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");


    const ordenarAdmins = (items) => {

        return [...items].sort((a, b) =>
            (a.email || "").localeCompare(b.email || "")
        );

    };


    const loadAdmins = async () => {

        try {

            const response = await getAdmins();

            // Mostramos solamente los documentos nuevos
            // cuyo ID es el propio email.
            // Así ignoramos temporalmente los docs viejos por UID.
            const adminsPorEmail = response.filter(admin =>
                admin.email &&
                admin.id === admin.email.toLowerCase()
            );

            setAdmins(
                ordenarAdmins(adminsPorEmail)
            );

        } catch (error) {

            console.error(error);

            setError(
                "No se pudieron cargar los administradores."
            );

        } finally {

            setLoading(false);

        }

    };


    useEffect(() => {

        loadAdmins();

    }, []);


    const handleSubmit = async (e) => {

        e.preventDefault();

        const adminEmail = email
            .trim()
            .toLowerCase();

        if (!adminEmail) {
            return;
        }

        setSaving(true);
        setError("");
        setSuccess("");


        try {

            await createAdmin(adminEmail);

            setAdmins(prev =>
                ordenarAdmins([
                    ...prev,
                    {
                        id: adminEmail,
                        email: adminEmail
                    }
                ])
            );

            setEmail("");

            setSuccess(
                `${adminEmail} fue agregado como administrador.`
            );

        } catch (error) {

            console.error(error);

            if (error.message === "admin-exists") {

                setError(
                    "Ese usuario ya es administrador."
                );

            } else {

                setError(
                    "No se pudo agregar el administrador."
                );

            }

        } finally {

            setSaving(false);

        }

    };


    const handleDelete = async (admin) => {

        if (
            admin.email.toLowerCase() ===
            currentUserEmail.toLowerCase()
        ) {

            setError(
                "No podés eliminar tu propio acceso."
            );

            return;

        }


        const confirmed = window.confirm(
            `¿Seguro que querés quitar el acceso de administrador a ${admin.email}?`
        );


        if (!confirmed) {
            return;
        }


        setError("");
        setSuccess("");


        try {

            await deleteAdmin(admin.email);

            setAdmins(prev =>
                prev.filter(item =>
                    item.email !== admin.email
                )
            );

            setSuccess(
                `${admin.email} dejó de ser administrador.`
            );

        } catch (error) {

            console.error(error);

            setError(
                "No se pudo eliminar el administrador."
            );

        }

    };


    if (loading) {

        return (
            <p>
                Cargando administradores...
            </p>
        );

    }


    return (
        <div className="admin-administradores">

            <div className="admin-section-title">

                <h2>
                    Administradores
                </h2>

                <span>
                    {admins.length} administradores
                </span>

            </div>


            <form
                className="admin-add-admin"
                onSubmit={handleSubmit}
            >

                <div className="admin-form-group">

                    <label>
                        Agregar administrador
                    </label>

                    <input
                        type="email"
                        value={email}
                        onChange={(e) =>
                            setEmail(e.target.value)
                        }
                        placeholder="email@gmail.com"
                        required
                    />

                    <small>
                        La persona deberá ingresar al administrador
                        utilizando esta misma cuenta de Google.
                    </small>

                </div>


                <button
                    type="submit"
                    disabled={saving}
                >
                    {saving
                        ? "Agregando..."
                        : "+ Agregar administrador"
                    }
                </button>

            </form>


            {error &&
                <p className="admin-error">
                    {error}
                </p>
            }


            {success &&
                <p className="admin-success">
                    {success}
                </p>
            }


            <div className="admin-admin-list">

                {admins.map(admin => {

                    const isCurrent =
                        admin.email.toLowerCase() ===
                        currentUserEmail.toLowerCase();


                    return (
                        <div
                            className="admin-admin-row"
                            key={admin.id}
                        >

                            <div className="admin-admin-info">

                                <strong>
                                    {admin.email}
                                </strong>

                                {isCurrent &&
                                    <span>
                                        Tu cuenta
                                    </span>
                                }

                            </div>


                            <button
                                type="button"
                                className={
                                    isCurrent
                                        ? "admin-delete disabled"
                                        : "admin-delete"
                                }
                                disabled={isCurrent}
                                onClick={() =>
                                    handleDelete(admin)
                                }
                            >
                                {isCurrent
                                    ? "Cuenta actual"
                                    : "Eliminar acceso"
                                }
                            </button>

                        </div>
                    );

                })}

            </div>

        </div>
    );

};


export default AdminAdministradores;